"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildWallet = exports.fetchManaBalance = void 0;
// import { ContractName, getContract } from 'decentraland-transactions'
// import { Contract, providers, utils } from 'ethers'
const eth_1 = require("../../lib/eth");
const chainConfiguration_1 = require("../../lib/chainConfiguration");
// @ts-ignore
function fetchManaBalance(chainId, address) {
    return __awaiter(this, void 0, void 0, function* () {
        return 0;
    });
}
exports.fetchManaBalance = fetchManaBalance;
function buildWallet() {
    return __awaiter(this, void 0, void 0, function* () {
        const provider = yield eth_1.getConnectedProvider();
        if (!provider) {
            // This could happen if metamask is not installed
            throw new Error('Could not connect to TRON');
        }
        const tronWeb = window.tronWeb;
        // @ts-ignore
        const address = tronWeb.defaultAddress.base58;
        const chainId = 1;
        const config = chainConfiguration_1.getChainConfiguration(chainId);
        const networks = {};
        for (const network of Object.keys(config.networkMapping)) {
            const networkChainId = config.networkMapping[network];
            networks[network] = {
                chainId: networkChainId,
                mana: yield fetchManaBalance(networkChainId, address)
            };
        }
        return {
            address: address,
            providerType: eth_1.getConnectedProviderType(),
            networks: networks,
            network: config.network,
            chainId
        };
    });
}
exports.buildWallet = buildWallet;
//# sourceMappingURL=utils.js.map